import React, { useState } from 'react';
import ReportForm from './ReportForm';
import PsychophysicalForm from './PsychophysicalForm';
import AttestationForm from './AttestationForm';
import PageHeader from '../common/PageHeader';

const CARDS = [
    { key: 'weekly', title: 'Nedeljni', sub: 'Excel za kompaniju (zip) ili vozača', img: '/images/reports/weeklyReport.jpg' },
    { key: 'quartal', title: 'Kvartalni', sub: 'Tromesečni pregled radnog vremena', img: '/images/reports/quartalReport.png' },
    { key: 'psycho', title: 'Psihofizičko stanje', sub: 'Mesečna evidencija po vozačima', img: '/images/reports/psychophysicalReport.png' },
    { key: 'attestation', title: 'Potvrda o aktivnostima', sub: 'PDF potvrde za pauze duže od 45 h', img: '/images/reports/activitiesAttestationReport.PNG' },
];

export default function Reports() {
    const [open, setOpen] = useState(null);
    const close = () => setOpen(null);
    return (
        <>
            <PageHeader title="Generiši izveštaj" subtitle="Izaberite vrstu izveštaja, zatim period i kompaniju ili vozača." />
            <div className="report-cards">
                {CARDS.map((c) => (
                    <button type="button" key={c.key} className="report-card" onClick={() => setOpen(c.key)} aria-label={`Otvori izveštaj: ${c.title}`}>
                        <span className="report-card-title"><span>{c.title}<small>{c.sub}</small></span><i className="bi bi-arrow-up-right" aria-hidden="true" /></span>
                        <span className="report-preview"><img src={c.img} alt="" /></span>
                        <span className="report-card-action">Pripremi izveštaj <i className="bi bi-arrow-right" aria-hidden="true" /></span>
                    </button>
                ))}
            </div>
            {open === 'weekly' && <ReportForm exportType={1} titlePrefix="Nedeljni" onClose={close} />}
            {open === 'quartal' && <ReportForm exportType={3} titlePrefix="Kvartalni" onClose={close} />}
            {open === 'psycho' && <PsychophysicalForm onClose={close} />}
            {open === 'attestation' && <AttestationForm onClose={close} />}
        </>
    );
}
